export default function mergeSpeakers(data) {
  return data.reduce((acc, item) => {
    const last = acc[acc.length - 1];
    if (last && last.speaker === item.speaker) {
      last.end = item.end;
      last.text += ` ${item.text.trim()}`;
    } else {
      acc.push({ ...item, text: item.text.trim() });
    }
    return acc;
  }, []);
}
